import { useContext } from 'react'
import invariant from 'tiny-invariant'

import { CartContext } from '@/src/domains/cart/contexts/Cart.context'

export const useCart = () => {
  const cart = useContext(CartContext)

  invariant(cart, 'useCart must be used within a CartProvider')

  return cart
}
